import { TournamentConfig, Signup } from '@/services/tournamentService';

// Demo data — used only on the /demo page. Nothing here touches real signups.

export const DEMO_TOURNAMENT: TournamentConfig = {
  id: 'demo',
  date: '2026-09-26',
  time: '13:00',
  duration: 120,
  location: 'HIT Padel Trondheim',
  locationUrl: 'https://maps.app.goo.gl/mNAPkh93NRM3JYuz8',
  courts: [1, 2, 3, 4, 5],
  maxPlayers: 20,
  level: 'Alle nivåer / All levels',
  announcementText: 'Ukentlig padelturnering',
  announcementTextEn: 'Weekly padel tournament',
  tournamentFormat: 'americano',
  doorCode: '7695#',
};

const CONFIRMED: Array<[string, string]> = [
  ['Lars Føleide', '+4798454499'],
  ['Jonas Fløisvik', '+4748203272'],
  ['Fredrik Håstein', '+4747902302'],
  ['Joakim Nordeng Moulia', '+4794881285'],
  ['William Stadheim', '+4746863627'],
  ['Martin Viken', '+4798496947'],
  ['Kristian Sannan Skorild', '+4790733644'],
  ['Henrik Nordvik', '+4790689723'],
  ['Eirik Solberg', '+4746640682'],
  ['Camilla Sæther Andås', '+4790069010'],
  ['Tran D', '+4798682509'],
  ['Emma Ciric', '+4748392292'],
  ['Eirik Myran', '+4794828386'],
  ['Ola Wold Hagen', '+4796049644'],
  ['Anna Ciric', '+4748392284'],
  ['Diem Tran', '+4746415050'],
  ['Håvard Lian', '+4746520016'],
  ['Ørjan Kjellevoll', '+4746837865'],
  ['Benjamin Pedersen', '+4747217035'],
  ['Eivind Kallmyr', '+4740649593'],
];

const WAITLIST: Array<[string, string]> = [
  ['Anders Johnsen', '+4791234567'],
  ['Ketis Sivanesarajah', '+4792345678'],
  ['Atle Sund', '+4798670349'],
  ['Kristian Tveråmo Aastveit', '+4745516324'],
];

function toEmail(name: string): string {
  return (
    name
      .toLowerCase()
      .replace(/æ/g, 'ae')
      .replace(/ø/g, 'o')
      .replace(/å/g, 'a')
      .replace(/[^a-z\s]/g, '')
      .trim()
      .replace(/\s+/g, '.') + '@example.com'
  );
}

// Signup timestamps are spaced one minute apart so ordering is stable.
const BASE_TIME = new Date('2026-09-20T10:00:00Z').getTime();

function toSignups(rows: Array<[string, string]>, offset: number): Signup[] {
  return rows.map(([name, phone], i) => ({
    id: `demo-${offset + i + 1}`,
    tournamentId: DEMO_TOURNAMENT.id,
    name,
    email: toEmail(name),
    phone,
    signedUpAt: new Date(BASE_TIME + (offset + i) * 60 * 1000).toISOString(),
  }));
}

export const DEMO_SIGNUPS: Signup[] = [
  ...toSignups(CONFIRMED, 0),
  ...toSignups(WAITLIST, CONFIRMED.length),
];
